import { createAction } from '@reduxjs/toolkit';
import { Modal } from '../../types/ModalTypes/Modal';

export const REMOVE_MODAL = 'REMOVE_MODAL';

export const removeModal = createAction(
    REMOVE_MODAL,
    (id: Modal['id']) => ({ payload: id }),
);
